












import Vue from 'vue'

export interface ChannelListFilterSettings {
  filterStr: string
  unreadOnly: boolean
}

export default Vue.extend({
  data() {
    return {
      filterString: '',
      unreadOnly: false
    }
  },
  methods: {
    toggleUnreadOnly() {
      this.unreadOnly = !this.unreadOnly
    }
  },
  updated(): void {
    const filterSettings: ChannelListFilterSettings = {
      filterStr: this.filterString,
      unreadOnly: this.unreadOnly
    }
    this.$emit('filterChange', filterSettings)
  }
})
